// extracted by mini-css-extract-plugin
export default {"list":"foundPricesCell_list__dxZN-","row":"foundPricesCell_row__w1qK1","photoLink":"foundPricesCell_photoLink__LK-WA","more":"foundPricesCell_more__weuWx"};